import Ad from "@/views/storage/Adv";
import Cabinets from "@/views/storage/Cabinets";
import CabinetDetail from "@/views/storage/CabinetDetail";
import Notice from "@/views/storage/Notice";
import Hintstorage from "@/views/storage/HintStorage"

const routes = [
    {
        path: "/storage/ad",
        name: "ad",
        meta: {
            title: "闪光存包柜"
        },
        component: Ad
    },
    {
        path: "/storage/cabinets",
        name: "cabinets",
        meta: {
            title: "闪光存包柜"
        },
        component: Cabinets
    },
    {
        path: "/storage/cabinet-detail",
        name: "cabinetDetail",
        meta: {
            title: "存包详情"
        },
        component: CabinetDetail
    },
    {
        path: "/notice",
        name: "notice",
        meta: {
            title: "消息中心"
        },
        component: Notice
    },
    {
        path: "/qrcode/flash-device",
        name: "hintstorage",
        meta: {
            title: "存包提示"
        },
        component: Hintstorage
    },

];
export default routes;
